// Telefónne číslo – rovnaké pravidlá ako backend/services/phoneService.js

// Pre HTML atribút pattern: voliteľné "+" a 9 až 15 číslic, medzery sú povolené
export const PHONE_PATTERN = " *\\+?( *\\d){9,15} *";

export const PHONE_TITLE =
  "Telefónne číslo musí mať 9 až 15 číslic, napr. 0905 123 456 alebo +421 905 123 456.";
